import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import EditArticleModal from '../../Modals/Article/EditArticleModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllArticlesTable extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            articleInEdit: null,
            articleInEditIndex: -1,
        };
    }
    updateArticle =( index, id, data ) => {
        this.props.updateArticle( id, data )
        .then( ( article ) => {
            return this.props.onArticleUpdated && this.props.onArticleUpdated( index, article );
        } );
    }
    openEditModal = ( index, user ) => {
        this.setState( { articleInEdit: user, articleInEditIndex: index } );
    }
    onEditSubmit = ( article ) => {
        var index = this.state.articleInEditIndex;
        this.props.onArticleUpdated( index, article );
        this.setState( { articleInEdit: null, articleInEditIndex: -1 } );
    }
    onEditClose = () => {
        this.setState( { articleInEdit: null, articleInEditIndex: -1 } );
    }

    render() {
        const { articles } = this.props;

        return (
            <div className={ style.allArticle }>
                <InfiniteTable
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    { this.arrayTableRows( articles ) }
                </InfiniteTable>
                { this.state.articleInEdit &&
                    <EditArticleModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    article={ this.state.articleInEdit } />
                }
            </div>
        );
    }


    arrayTableRows = ( articles ) => {
        var rows = articles.map( ( article, index ) => {
            var author = article.author || {};
            var individualSlug = `/admin/content/${ article.id }`;
            return (
                <InfiniteTable.Row key={ article.id } className='dl-table-body'>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        <TextTruncate text={ article.title }
                        line={ 2 } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { author.displayName }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { article.categories.map( category => ( category || {} ).name ).join( ', ' ) }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }></Link>
                        { article.desires.length }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }></Link>
                        { article.featured !== null ? ( <Icon source='fontAwesome' icon='fas/faCheck' style={ { color: 'inheirit' } } /> ) : null }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, article );
                            } }/>
                            <DLMenu.Item text={ !article.published ? 'Publish' : 'Unpublish' }
                            onClick={ () => {
                                this.updateArticle( index, article.id, {
                                    published: !article.published,
                                    title: article.title,
                                } );
                            } }/>
                            <DLMenu.Item text={ article.featured ? 'UnFeature' : 'Feature' }
                            onClick={ () => {
                                this.updateArticle( index, article.id, {
                                    featured: !article.featured,
                                    title: article.title,
                                } );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );
        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell>
                    ARTICLE NAME
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    USER
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    CATEGORY
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    PRODUCT
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    FEATURED
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
AllArticlesTable.defaultProps = {
    onArticleUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateArticle: ( id, data ) => {
            return dAPI.patch( `/admin/content/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllArticlesTable );
